import { render } from "./AddPropositionReponse.vue?vue&type=template&id=c77e28d8&scoped=true&ts=true"
import script from "./AddPropositionReponse.vue?vue&type=script&lang=ts"
export * from "./AddPropositionReponse.vue?vue&type=script&lang=ts"

import "./AddPropositionReponse.vue?vue&type=style&index=0&id=c77e28d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c77e28d8"]])

export default __exports__